document.addEventListener("DOMContentLoaded", function() {
  const counters = document.querySelectorAll('.counter-section_number');
  const speed = 150; // Adjust speed (lower = faster)

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const counter = entry.target;
        const updateCount = () => {
          const target = +counter.getAttribute('data-target').replace(/\D/g, '');
          const current = +counter.innerText.replace(/\D/g, '');
          const increment = target / speed;

          if (current < target) {
            counter.innerText = Math.ceil(current + increment) + (counter.getAttribute('data-target').includes('%') ? '%' : '');
            setTimeout(updateCount, 20);
          } else {
            counter.innerText = counter.getAttribute('data-target');
          }
        };
        updateCount();
        observer.unobserve(counter); // Run only once per element
      }
    });
  }, { threshold: 0.4 });

  counters.forEach(counter => observer.observe(counter));
});